module.exports = __webpack_public_path__ + "static/media/bank10.c86215b2.png";